import elements from './utils/elements';
import * as eventListeners from './utils/event-listeners';
import config from './utils/config';
import lazyLoadAttribute from './lazyLoadAttribute';
import setNotifications from './utils/setNotifications';
import { Cookies } from './utils/cookies';
import * as algoliaSearchInsights from './utils/algolia/trackAlgoliaEvents';

const cartIcon999 = `<svg id="assets-cart-icon-999" class="assets-site-header__menu-cart-icon" xmlns="http://www.w3.org/2000/svg" viewBox="1510.724 16 34.261 28.99" height="35" width="35"  aria-hidden="true" focusable="false"><path d="M1537.078 42.354a2.636 2.636 0 1 0 .772-1.864 2.54 2.54 0 0 0-.772 1.864z"></path><path d="M1544.593 19.026a1.266 1.266 0 0 0-.927-.39h-24.727q-.023-.145-.095-.526t-.113-.608a3.632 3.632 0 0 0-.154-.545 1.642 1.642 0 0 0-.27-.5 1.314 1.314 0 0 0-.41-.32 1.257 1.257 0 0 0-.588-.133h-5.27a1.267 1.267 0 0 0-.927.39 1.293 1.293 0 0 0 0 1.854 1.267 1.267 0 0 0 .927.39h4.2l3.644 16.943q-.04.084-.422.784t-.607 1.225a2.26 2.26 0 0 0-.226.812 1.335 1.335 0 0 0 1.32 1.32h21.08a1.318 1.318 0 0 0 0-2.637h-18.94a3.975 3.975 0 0 0 .492-1.317 2.224 2.224 0 0 0-.052-.453q-.05-.247-.123-.546t-.093-.443l21.5-2.512a1.278 1.278 0 0 0 .844-.443 1.3 1.3 0 0 0 .33-.875v-10.54a1.268 1.268 0 0 0-.395-.93z"></path><path d="M1518.63 42.354a2.636 2.636 0 1 0 .772-1.864 2.537 2.537 0 0 0-.772 1.864z"></path></svg>`;
const cartIconEmpty = `<svg id="assets-cart-icon-empty" class="assets-site-header__menu-cart-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" height="35" width="35"  aria-hidden="true" focusable="false"><path d="M26.9,29.6c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7c0-1.5-1.2-2.7-2.7-2.7c-0.7,0-1.4,0.3-1.9,0.8 C27.2,28.2,26.9,28.9,26.9,29.6z"></path><path d="M8.1,29.6c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7c0-1.5-1.2-2.7-2.7-2.7c-0.7,0-1.4,0.3-1.9,0.8 C8.4,28.2,8.1,28.9,8.1,29.6z"></path><path d="M34.6,5.8c-0.2-0.3-0.6-0.4-0.9-0.4c-1.2,0-1.3,1.2-1.3,1.2s0,8.3,0,9.2c0,0.9-0.5,0.9-1.4,1C30,16.9,11.2,19,11.2,19 L8.4,5.4c0-0.1,0-0.3-0.1-0.5c0-0.3-0.1-0.5-0.1-0.6C8.1,4,8.1,3.9,8,3.7C8,3.5,7.9,3.3,7.7,3.2C7.6,3,7.5,2.9,7.3,2.8 C7.1,2.7,6.9,2.7,6.7,2.7H1.3C1,2.7,0.6,2.8,0.4,3.1c-0.5,0.5-0.5,1.3,0,1.9c0,0,0,0,0,0C0.6,5.2,1,5.4,1.3,5.4h4.3l3.7,17.3 c0,0.1-0.2,0.3-0.4,0.8c-0.3,0.5-0.5,0.9-0.6,1.3c-0.1,0.3-0.2,0.5-0.2,0.8c0,0.7,0.6,1.3,1.3,1.3H31c0.7,0,1.3-0.6,1.3-1.3 s-0.6-1.3-1.3-1.3H11.6c0.2-0.4,0.4-0.9,0.5-1.3c0-0.2,0-0.3-0.1-0.5c0-0.2-0.1-0.4-0.1-0.6c0-0.2-0.1-0.4-0.1-0.5l22-2.6 c0.3,0,0.6-0.2,0.9-0.5c0.2-0.2,0.3-0.6,0.3-0.9V6.7C35,6.4,34.9,6,34.6,5.8L34.6,5.8z"></path><g><path d="M16.8,8.7c0-2.7,1.2-4.2,3.1-4.2c1.9,0,3.1,1.5,3.1,4.2c0,2.7-1.1,4.2-3.1,4.2C17.9,12.8,16.8,11.3,16.8,8.7z M21.5,8.6 c0-1.9-0.6-2.9-1.7-2.9c-1.1,0-1.7,1-1.7,2.9c0,1.9,0.6,2.9,1.7,2.9C20.9,11.6,21.5,10.6,21.5,8.6z"></path></g></svg>`;
const cartIconGreaterThan999 = `<svg id="assets-cart-icon-greater-than-999" class="assets-site-header__menu-cart-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.27 28.99" height="35" width="35"  aria-hidden="true" focusable="false"><path d="M26.35 26.35a2.64 2.64 0 1 0 .77-1.86 2.54 2.54 0 0 0-.77 1.86zM7.91 26.35a2.64 2.64 0 1 0 .77-1.86 2.54 2.54 0 0 0-.77 1.86z"></path><path d="M33.87 3a1.27 1.27 0 0 0-.93-.39H8.21q0-.15-.09-.53L8 1.5a3.64 3.64 0 0 0-.15-.5 1.64 1.64 0 0 0-.27-.5 1.32 1.32 0 0 0-.41-.36A1.26 1.26 0 0 0 6.58 0H1.31a1.27 1.27 0 0 0-.92.39 1.29 1.29 0 0 0 0 1.83 1.27 1.27 0 0 0 .93.39h4.2l3.64 16.97-.42.78q-.38.7-.61 1.22a2.26 2.26 0 0 0-.23.81 1.33 1.33 0 0 0 1.32 1.32H30.3a1.32 1.32 0 0 0 0-2.64H11.36a4 4 0 0 0 .49-1.32 2.22 2.22 0 0 0-.05-.45q-.05-.25-.12-.55t-.09-.44l21.5-2.51a1.28 1.28 0 0 0 .84-.44 1.3 1.3 0 0 0 .33-.87V4a1.27 1.27 0 0 0-.39-1zm-9.75 3a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5zm-6 0a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5zm10.4 5a9.61 9.61 0 0 1-7.38 3 9.61 9.61 0 0 1-7.37-3 .61.61 0 0 1 .11-.84.57.57 0 0 1 .77 0 6.7 6.7 0 0 0 1.61 1.3 9.32 9.32 0 0 0 4.88 1.29 8.56 8.56 0 0 0 6.51-2.58.57.57 0 0 1 .8-.1.61.61 0 0 1 .07.93z"></path></svg>`;

class Cart {
    get currentCartQty() {
        return Number(elements.header.getCartCount().innerHTML);
    }

    setQuantity(newQuantity = 0) {
        const newQuantityValidated = Number(newQuantity);
        if (newQuantityValidated < 0) {
            throw new Error('Cart quantity cannot be negative');
        }
        if (newQuantityValidated >= 1000) {
            elements.header.getCartIconContainer().innerHTML = cartIconGreaterThan999;
            elements.header.getCartIcon().classList.add('assets-site-header__menu-cart-icon--green');
            elements.header.getCartCount().innerHTML = '';
            elements.header
                .getCartLabel()
                .getElementsByClassName(
                    'assets-site-header__menu-cart',
                )[0].ariaLabel = `${newQuantityValidated} items in your cart`;
        } else if (newQuantityValidated === 0) {
            elements.header.getCartIconContainer().innerHTML = cartIconEmpty;
            elements.header.getCartIcon().classList.remove('assets-site-header__menu-cart-icon--green');
            elements.header.getCartCount().innerHTML = '';
            elements.header.getCartLabel().getElementsByClassName('assets-site-header__menu-cart')[0].ariaLabel =
                'No items in your cart';
            document.querySelector('.assets-mc-empty').style.display = 'block';
            document.querySelector('.assets-mc-content').style.display = 'none';
        } else {
            elements.header
                .getCartLabel()
                .getElementsByClassName('assets-site-header__menu-cart')[0].ariaLabel = `${newQuantityValidated} item${
                newQuantityValidated > 1 ? 's' : ''
            } in your cart`;
            elements.header.getCartIconContainer().innerHTML = cartIcon999;
            elements.header.getCartIcon().classList.add('assets-site-header__menu-cart-icon--green');
            elements.header.getCartCount().innerHTML = Math.max(0, newQuantityValidated);
        }
    }

    increaseQuantity(ammount = 1) {
        this.setQuantity(this.currentCartQty + Number(ammount));
    }

    decreaseQuantity(ammount = 1) {
        this.setQuantity(this.currentCartQty - Number(ammount));
    }
}

const defaultContactFormConfig = {
    seInfo: {
        image: undefined,
        name: undefined,
        firstName: undefined,
        url: undefined,
    },
    questionAbout: 'Need help choosing?',
    hiddenFields: [],
    phoneNumber: '(800) 222-4700',
    singleProduct: false,
    type: undefined,
    search: undefined,
    userInfo: {
        name: undefined,
        firstName: undefined,
        email: undefined,
        phoneNumber: undefined,
        profileId: undefined,
    },
};

const $sw = {
    cart: new Cart(),
    cookies: new Cookies(document.cookie),
    algoliaSearchInsights: {
        ...algoliaSearchInsights,
    },
    notifications: {
        boot() {
            if (!config.notificationsEnabled) {
                return;
            }
            fetch(`${config.notificationsServiceRootUrl}/customer-notifications-api/session`, {
                credentials: 'include'
            }).then(response => response.json()).then(notificationsResponse => {
                $sw.notifications.setAll(notificationsResponse.notifications.map(notification => {
                    const typeMap = {
                        'PRICE_DROP': 'pricedrop',
                        'BACK_IN_STOCK': 'backinstock',
                        'TIME_TO_REORDER': 'reorder',
                        'DEMO_AVAILABLE': 'demo'
                    };
                    const type = typeMap[notification.notificationType] ?? null;
                    const reasonMap = {
                        'RECENTLY_VIEWED': 'recentlyViewed',
                        'IN_CART': 'inCart',
                        'PREVIOUSLY_ORDERED': 'previousOrder'
                    };
                    const reason = reasonMap[notification.notificationReason] ?? null;
                    return {
                        type,
                        reason,
                        uid: notification.id,
                        link: notification.linkTo,
                        title: notification.title,
                        image: notification.imageUrl,
                        lastOrderDate: notification.lastOrderDate,
                        recieverType: notification.notificationRecieverType,
                        recieverValue: notification.notificationRecieverValue,
                        price: {
                            dollars: notification.priceDollars,
                            cents: notification.priceCents
                        },
                        oldPrice: notification && notification.originalPriceDollars && notification.originalPriceCents && {
                            dollars: notification.originalPriceDollars,
                            cents: notification.originalPriceCents
                        }
                    }
                }));
            });
        },
        getAll: () => window._all_notifications || [],
        add(notification) {
            const notifications = window._all_notifications || [];
            notification.uid = Date.now() * Math.random() * 10000;
            setNotifications([...notifications, notification]);
        },
        setAll(notifications) {
            setNotifications(notifications);
        },
        clear() {
            setNotifications([]);
        }
    },
    setSearchInput: value => {
        elements.header.searchInput.desktop().value = value;
        elements.header.searchInput.mobile().value = value;
    },
    eventListeners: {
        ...eventListeners,
    },
    config: {
        ...config,
    },
    lazyLoadAttribute,
    showContactForm: config => {
        if(!document.getElementById('siteContactForm')) {
            return;
        }
        $sw.eventListeners.whenProfileLoaded(profile => {
            if (profile?.sales_engineer !== undefined) {
                config.seInfo = {
                    name: profile.sales_engineer.name,
                    firstName: profile.sales_engineer.first_name,
                    url: profile.sales_engineer.bio_name,
                    image: profile.sales_engineer.image_url ? profile.sales_engineer.image_url : undefined,
                };
            }

            let cartId;

            const contactContext = {
                ...defaultContactFormConfig,
                ...config,
            };

            contactContext.userInfo.profileId = `${profile.customer_id}`;

            if (profile.email !== undefined) {
                contactContext.userInfo.email = profile.email;
            }

            if (profile.first_name !== undefined && profile.last_name !== undefined) {
                contactContext.userInfo.firstName = profile.first_name;
                contactContext.userInfo.name = `${profile.first_name} ${profile.last_name}`;
            } else {
                contactContext.userInfo.firstName = contactContext.userInfo.name = undefined;
            }
            cartId = profile.link;

            if (!contextContainsCartId(contactContext)) {
                contactContext.hiddenFields.push({ name: 'cartId', value: `${cartId}` });
            }

            if (contactContext.type === 'search') {
                contactContext.hiddenFields.push({ name: 'search', value: contactContext.search });
            }

            contactContext.hiddenFields.push({ name: 'type', value: contactContext.type });

            errorChecking(contactContext);

            const setSEInfo = () => {
                let seText;
                if (contactContext.seInfo.name !== undefined) {
                    seText = `${
                        contactContext.userInfo.firstName ? 'Hi ' + contactContext.userInfo.firstName + ', i' : 'I'
                    }f you have questions about ${
                        contactContext.singleProduct ? 'this product' : 'these products'
                    }, your personal Sales Engineer, <span>${
                        contactContext.seInfo.name
                    }</span>, is available to offer advice. ${
                        contactContext.seInfo.firstName
                    } has an extensive music background and intense training on all the products that we carry. ${
                        contactContext.seInfo.url
                            ? "Click <a href='https://www.sweetwater.com/" +
                              contactContext.seInfo.url +
                              "'>here</a> to read more about " +
                              contactContext.seInfo.firstName +
                              "'s background."
                            : ''
                    }`;
                } else {
                    seText = "Sweetwater's Sales Engineers have the experience to help!";
                }
                document.getElementById('seText').innerHTML = seText;
            };

            const setUserInfo = () => {
                if (contactContext.userInfo.name !== undefined) {
                    const userNameInput = document.getElementById('seq-yname');
                    userNameInput.value = contactContext.userInfo.name;
                    userNameInput.classList.add('filled');
                }
                if (contactContext.userInfo.email !== undefined) {
                    const emailInput = document.getElementById('seq-email');
                    emailInput.value = contactContext.userInfo.email;
                    emailInput.classList.add('filled');
                }
                if (contactContext.userInfo.phoneNumber !== undefined) {
                    const phoneNumberInput = document.getElementById('seq-phone');
                    phoneNumberInput.value = contactContext.userInfo.phoneNumber;
                    phoneNumberInput.classList.add('filled');
                }
                if (contactContext.userInfo.profileId !== undefined) {
                    document.getElementById('customerProfileId').value =
                        contactContext.userInfo.profileId == '0' ? '4' : contactContext.userInfo.profileId;
                }
            };

            const setContactFormFields = () => {
                document.getElementById('questionAbout').innerText = contactContext.questionAbout;
                document.getElementById(
                    'phoneNumber',
                ).innerHTML = `Call <a class="phone" href="tel:+1${contactContext.phoneNumber}">${contactContext.phoneNumber}</a> or email us below`;
            };

            const setSEImage = () => {
                if (contactContext.seInfo.image !== undefined) {
                    document.getElementById('product-question-image').src = contactContext.seInfo.image;
                    document.getElementById('button-se-image').src = contactContext.seInfo.image;
                }
            };

            const setHiddenFields = () => {
                const finalField = document.getElementById('last-field');
                contactContext.hiddenFields.forEach(fieldPair => {
                    finalField.insertAdjacentHTML(
                        'beforeend',
                        `<input type="hidden" name="${fieldPair.name}" value="${fieldPair.value}" />`,
                    );
                });
            };

            setSEInfo();
            setSEImage();
            setHiddenFields();
            setUserInfo();
            setContactFormFields();

            document.getElementById('siteContactForm').classList.remove('removed');
        });
    },
};

if (!window.$sw) {
    window.$sw = $sw;
}
export default window.$sw;

function errorChecking(contactContext) {
    if (contactContext.questionAbout == undefined) {
        throw new Error(
            'The contact form requires that there is a question format passed into the $sw object using the showContactForm method.',
        );
    } else if (contactContext.phoneNumber == undefined) {
        throw new Error(
            'The contact form requires that a sweetwater phone number is passed into the $sw object using the showContactForm method.',
        );
    } else if (contactContext.singleProduct == undefined) {
        throw new Error(
            'The contact form requires that a boolean for whether or not the user is looking at a page with a single product be passed into the $sw object using the showContactForm method',
        );
    }

    if (!contextContainsType(contactContext)) {
        throw new Error(
            `The contact form requires that a string be passed in for the type of page on which the contact form is being submitted.`,
        );
    }

    if (!contextContainsCartId(contactContext)) {
        throw new Error(`The hidden fields object must contain a cartId in order to be valid`);
    }

    if (typeof contactContext.seInfo.image !== 'string' && typeof contactContext.seInfo.image !== 'undefined') {
        throw new TypeError(
            `The seInfo.image url must be a string. It is currently of type ${typeof contactContext.seInfo.image}`,
        );
    }
    if (typeof contactContext.seInfo.name !== 'string' && typeof contactContext.seInfo.name !== 'undefined') {
        throw new TypeError(
            `The seInfo.name must be a string. It is currently of type ${typeof contactContext.seInfo.name}`,
        );
    }
    if (typeof contactContext.seInfo.firstName !== 'string' && typeof contactContext.seInfo.firstName !== 'undefined') {
        throw new TypeError(
            `The seInfo.firstName must be a string. It is currently of type ${typeof contactContext.seInfo.firstName}`,
        );
    }
    if (typeof contactContext.seInfo.url !== 'string' && typeof contactContext.seInfo.url !== 'undefined') {
        throw new TypeError(
            `The seInfo.url must be a string. It is currently of type ${typeof contactContext.seInfo.url}`,
        );
    }

    if (typeof contactContext.questionAbout !== 'string') {
        throw new TypeError(
            `The questionAbout must be a string. It is currently of type ${typeof contactContext.questionAbout}`,
        );
    }
    if (typeof contactContext.hiddenFields !== 'object') {
        throw new TypeError(
            `The questionAbout must be an array of objects containing HTML <input> element attribute name and values. It is currently of type ${typeof contactContext.hiddenFields}`,
        );
    }

    if (typeof contactContext.phoneNumber !== 'string') {
        throw new TypeError(
            `The phoneNumber must be a string. It is currently of type ${typeof contactContext.phoneNumber}`,
        );
    }
    if (typeof contactContext.singleProduct !== 'boolean') {
        throw new TypeError(
            `The singleProduct must be a boolean. It is currently of type ${typeof contactContext.singleProduct}`,
        );
    }

    if (typeof contactContext.userInfo.name !== 'string' && typeof contactContext.userInfo.name !== 'undefined') {
        throw new TypeError(
            `The userInfo.name must be either a string or undefined. It is currently of type ${typeof contactContext
                .userInfo.name}`,
        );
    }

    if (
        typeof contactContext.userInfo.profileId !== 'string' &&
        typeof contactContext.userInfo.profileId !== 'undefined'
    ) {
        throw new TypeError(
            `The userInfo.profileId must be either a string or undefined. It is currently of type ${typeof contactContext
                .userInfo.profileId}`,
        );
    }

    if (
        typeof contactContext.userInfo.firstName !== 'string' &&
        typeof contactContext.userInfo.firstName !== 'undefined'
    ) {
        throw new TypeError(
            `The userInfo.firstName must be either a string or undefined. It is currently of type ${typeof contactContext
                .userInfo.firstName}`,
        );
    }
    if (typeof contactContext.userInfo.email !== 'string' && typeof contactContext.userInfo.email !== 'undefined') {
        throw new TypeError(
            `The userInfo.email must be either a string or undefined. It is currently of type ${typeof contactContext
                .userInfo.email}`,
        );
    }
    if (
        typeof contactContext.userInfo.phoneNumber !== 'string' &&
        typeof contactContext.userInfo.phoneNumber !== 'undefined'
    ) {
        throw new TypeError(
            `The userInfo.phoneNumber must be either a string or undefined. It is currently of type ${typeof contactContext
                .userInfo.phoneNumber}`,
        );
    }
    if (typeof contactContext.userInfo.cartId !== 'string' && typeof contactContext.userInfo.cartId !== 'undefined') {
        throw new TypeError(
            `The userInfo.cartId must be either a string or undefined. It is currently of type ${typeof contactContext
                .userInfo.cartId}`,
        );
    }
}

function contextContainsCartId(context) {
    let containsCartId = false;
    context.hiddenFields.forEach(object => {
        if (object.name === 'cartId' && typeof object.value === 'string') containsCartId = true;
    });
    return containsCartId;
}

function contextContainsType(context) {
    let containsType = false;
    if (context.type !== undefined && typeof context.type === 'string') {
        containsType = true;
    }
    return containsType;
}
